import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useCallback, useMemo } from 'react';
import { Switch } from 'src/common/components/switch';
import { useCurrentSpace, useUpdateSpace } from 'src/hooks/space';
import { useIsFreeSpaceLimit, useIsShowAd } from 'src/hooks/space/use-is-pro-space';
import { transaction } from 'src/hooks/use-transaction';
import { bizTracker } from 'src/utils/biz-tracker';
import { Option } from '../option';

/** 页面广告 */
export const PageAd = () => {
  const { t } = useAppTranslation();
  const currentSpace = useCurrentSpace();
  const updateSpace = useUpdateSpace();
  const isFreeSpaceLimit = useIsFreeSpaceLimit();
  const isShowAd = useIsShowAd();

  const onSwitch = useCallback(
    (status: boolean) => {
      bizTracker.event('ad_switch_set', { is_open: status });
      transaction(() => {
        void updateSpace(currentSpace.uuid, {
          isShowAd: status,
        });
      });
    },
    [currentSpace.uuid, updateSpace]
  );

  const rightPart = useMemo(
    () => <Switch open={isShowAd} onSwitch={onSwitch} disabled={isFreeSpaceLimit} />,
    [isFreeSpaceLimit, isShowAd, onSwitch]
  );

  return (
    <Option
      title={t('components.space_setting.page_ad.title')}
      showSpacePlan
      description={t('components.space_setting.page_ad.description')}
      rightPart={rightPart}
    />
  );
};
